export default __webpack_public_path__ + "static/media/xero.5888993f.svg";